import { getCookie} from '@iso/lib/helpers/session';

// const language = getCookie('language')?getCookie('language'):'english';
const language = getCookie('language')?getCookie('language'):'dutch';
export const langDir = 'ltr';

export default language;
